import React from "react";
import { Button, Icon } from "@shared/components";
import { useLogout } from "@shared/hooks";

import "./index.scss";

const MobileLockScreen: React.FC = () => {
  const logout = useLogout();

  return (
    <div className="mobile-lock-screen">
      <div className="mobile-lock-screen-logo"></div>
      Please Use The Desktop
      <br />
      App To Continue
      <Button className="outline-dark logout-btn" onClick={logout}>
        <Icon type="logout" />
        <span>Log Out</span>
      </Button>
    </div>
  );
};

export default MobileLockScreen;
